import React, { Suspense, Fragment, lazy } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import LoadingScreen from 'src/components/LoadingScreen';
import CommonLayout from 'src/layouts/CommonLayout';
import ServiceLayout from 'src/layouts/ServiceLayout';
import PublicLayout from 'src/layouts/PublicLayout';
import ProfileLayout from 'src/layouts/ProfileLayout'
import ErrorLayout from 'src/layouts/ErrorLayout';
import AuthGuard from 'src/components/AuthGuard';

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Component {...props} />
                  )}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
);

const routes = [
  {
    exact: true,
    path: '/404',
    layout: ErrorLayout,
    component: lazy(() => import('src/views/errors/NotFoundView'))
  },
  {
    path: '/profile',
    guard: AuthGuard,
    layout: ProfileLayout,
    routes: [
      {
        exact: true,
        path: '/profile/edit',
        component: lazy(() => import('src/views/profile/EditView'))
      },
      {
        exact: true,
        path: '/profile/edit_password',
        component: lazy(() => import('src/views/profile/PasswordView'))
      },
    ]
  },
  {
    path: '/common',
    guard: AuthGuard,
    layout: CommonLayout,
    routes: [
      {
        exact: true,
        path: '/common/top',
        component: lazy(() => import('src/views/common/HomeView'))
      },
      {
        exact: true,
        path: '/common/customer_notifications',
        component: lazy(() =>
          import(
            'src/views/common/customer_notification/CustomerNotificationListView'
          )
        )
      },
      {
        exact: true,
        path: '/common/customer_notifications/:id',
        component: lazy(() =>
          import(
            'src/views/common/customer_notification/CustomerNotificationShowView'
          )
        )
      },
      {
        exact: true,
        path: '/common/accounts',
        component: lazy(() =>
          import('src/views/common/account/AccountListView')
        )
      },
      {
        exact: true,
        path: '/common/accounts/new',
        component: lazy(() =>
          import('src/views/common/account/CreateAccountView')
        )
      },
      {
        exact: true,
        path: '/common/documents',
        component: lazy(() =>
          import('src/views/common/document/DocumentListView')
        )
      },
      {
        exact: true,
        path: '/common/personal_informations',
        component: lazy(() =>
          import(
            'src/views/common/personal_information/PersonalInformationListView'
          )
        )
      },
      {
        exact: true,
        path: '/common/personal_informations/new',
        component: lazy(() =>
          import(
            'src/views/common/personal_information/CreatePersonalInformationView'
          )
        )
      },
      {
        exact: true,
        path: '/common/group_numbers',
        component: lazy(() =>
          import('src/views/common/group_number/GroupNumberListView')
        )
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '/service',
    guard: AuthGuard,
    layout: ServiceLayout,
    routes: [
      {
        exact: true,
        path: '/service/top',
        component: lazy(() => import('src/views/service/HomeView'))
      },
      {
        exact: true,
        path: '/service/bbt_racks',
        component: lazy(() => import('src/views/service/rack/RackListView'))
      },
      {
        exact: true,
        path: '/service/system_monitoring_messages',
        component: lazy(() =>
          import(
            'src/views/service/system_monitoring_message/SystemMonitoringMessageListView'
          )
        )
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '/public',
    layout: PublicLayout,
    routes: [
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '*',
    routes: [
      {
        exact: true,
        path: '/',
        guard: AuthGuard,
        component: () => <Redirect to="/common/top" />
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];
export default routes;
